import React from "react";
import { CircularProgress, Container } from "@material-ui/core";
import Catalog from "./Catalog";
import { Alert } from "react-bootstrap"; // This could easily be removed.
import songsAPI from "restApi/songsApi";
import eventsApi from "restApi/eventsApi";
import { UserContext } from "contexts/UserContext";

export default () => {
  const { user } = React.useContext(UserContext);
  // Every team member can propose a song from the catalog page - only
  // leaders/admins get directToCatalog (skips the pending-approval step),
  // matching SongViewSet.create()'s own leader-or-admin gate (api/views.py).
  // is_team_leader and is_team_admin are independent flags, so both need
  // checking, not just one.
  const canAddDirectly = !!(user.is_team_leader || user.is_team_admin);
  const [state, setState] = React.useState({
    songs: null,
    events: null,
    loading: true,
    error: null,
  });

  React.useEffect(() => {
    const failed = () =>
      setState({
        songs: [],
        events: [],
        loading: false,
        error: "Couldn't load the catalog - try again in a moment.",
      });
    songsAPI
      .getSongs()
      .then((res) => {
        const songs = res.data;
        return eventsApi.getUpcomingEvents().then((res) => {
          const events = res.data;
          setState({ songs: songs, events: events, loading: false, error: null });
        });
      })
      .catch(failed);
  }, []);

  const handleAssignEvent = (song, events) => {
    let updatedEvents = state.events;
    const initialEventsWithSong = state.events.filter(
      (e) => e.song_list.findIndex((songId) => songId === song.id) > -1
    );
    // Remove songs from events that are no longer assigned.
    initialEventsWithSong.forEach((ie) => {
      if (events.findIndex((e) => e.id === ie.id) === -1) {
        const index = updatedEvents.findIndex((ue) => ue.id === ie.id);
        let event = updatedEvents[index];
        updatedEvents.splice(index, 1);
        event.song_list = event.song_list.filter(
          (songId) => songId !== song.id
        );
        updatedEvents.push(event);
      }
    });
    // Add song to events that are newly assigned.
    events.forEach((e) => {
      if (
        initialEventsWithSong.findIndex((event) => event.id === e.id) === -1
      ) {
        const index = updatedEvents.findIndex((event) => event.id === e.id);
        let event = updatedEvents[index];
        updatedEvents.splice(index, 1);
        event.song_list.push(song.id);
        updatedEvents.push(event);
      }
    });
    setState({ ...state, events: updatedEvents });
  };

  const handleDeleteSong = (song) => {
    const { songs } = state;
    setState({
      ...state,
      songs: songs.filter((s) => s.url !== song.url),
    });
  };

  // A song edited in place (desktop): swap in the saved copy.
  const handleSongUpdated = (saved) => {
    setState((prev) => ({
      ...prev,
      songs: prev.songs.map((s) => (s.id === saved.id ? { ...s, ...saved } : s)),
    }));
  };

  return (
    <Container maxWidth="xl">
      {state.loading ? (
        <div
          style={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      ) : state.error ? (
        <Alert
          style={{ backgroundColor: "#424242", color: "rgb(191, 199, 199)" }}
        >
          Error: {state.error}
        </Alert>
      ) : (
        <Catalog
          songs={state.songs}
          menuActions={{
            assignEvent: handleAssignEvent,
            // Presence gates the Edit item. On mobile SongMenuButton
            // navigates to the edit page; the desktop layout (Catalog)
            // swaps in its own function to edit in the detail pane.
            edit: true,
            delete: handleDeleteSong,
          }}
          events={state.events}
          onSongUpdated={handleSongUpdated}
          canAddDirectly={canAddDirectly}
        />
      )}
    </Container>
  );
};
